<template>
  <edit-field label="Address" icon="home" v-model="aValue" />
</template>

<script>
import EditField from '@/components/edit-field'

export default {
  name: 'google-autocomplete',
  components: {
    EditField
  },
  props: {
    value: ''
  },
  data () {
    return {
      autocomplete: null
    }
  },
  computed: {
    aValue: {
      get () {
        return this.value
      },
      set (s) {
        this.$emit('input', s)
      }
    }
  },
  methods: {
    getAddressData () {
      this.aValue = this.autocomplete.getPlace().formatted_address
    }
  },
  mounted () {
    // eslint-disable-next-line
    this.autocomplete = new google.maps.places.Autocomplete(this.$el.querySelector('input#address'), {
      componentRestrictions: {
        country: 'au'
      },
      types: ['address']
    })
    this.autocomplete.addListener('place_changed', this.getAddressData)
    this.$el.querySelector('input#address').setAttribute('placeholder', '')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/google-autocomplete.vue